import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { APPLICATION_ACTIONS, CONVERSATION_IDS_API_ACTIONS, SCORECARD_PREVIEW_API_ACTIONS } from '../actions';
import { ApplicationService } from '../../core/services/application.service';
import { APPLICATION_REDUCER } from '../reducers/application.reducer';
import { Store } from '@ngrx/store';

@Injectable()
export class ApplicationEffects {
  constructor(
    private readonly applicationService: ApplicationService,
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  getConversationIDs$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONVERSATION_IDS_API_ACTIONS.get),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([, { queryName, value }]) => this.applicationService.getConversationIDs(queryName, value)),
      map((data) => CONVERSATION_IDS_API_ACTIONS.success({ data })),
      catchError((error: HttpErrorResponse) => of(CONVERSATION_IDS_API_ACTIONS.error({ error }))),
    );
  });

  getScorecardPreview$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(APPLICATION_ACTIONS.setDataQueryParam),
      map(() => SCORECARD_PREVIEW_API_ACTIONS.get()),
    );
  });
}
